import activities from "./operation/activities";
import companies from "./operation/companies";
import distances from "./operation/distances";
import listings from "./operation/listings";
import talents from "./operation/talents";
import contacts from "./operation/contacts";

export default {
  activities,
  companies,
  distances,
  listings,
  talents,
  contacts,
};
